import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function FeedbackSmartWateringPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/onboarding/question-pets-at-home')
  }

  return (
    <FeedbackPage
      emoji="💧"
      heading={t('pages.onboarding.feedbackSmartWatering.heading')}
      text={t('pages.onboarding.feedbackSmartWatering.text')}
      onSubmit={handleSubmit}
    />
  )
}
